import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import { isAuthenticated } from 'utils/auth';

export default function RequireAuth({ children }) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

RequireAuth.propTypes = { children: PropTypes.node.isRequired };
